import type { Topic } from '@atlassian/jira-servicedesk-knowledge-common/src/common/types.tsx';

export const removeTopic = (topics: Topic[], topicId: string): Topic[] =>
	topics.filter((topic) => topic.topicId !== topicId);
